import React from "react";
import "./Intellectualpropertyrights.css";
import Footer from "../Footer";

const Intellectualpropertyrights = () => {
  return (
    <>
    <div className="ipr-container">
      <h1 className="ipr-title">حقوق الملكية الفكرية</h1>

      <section className="ipr-section">
        <h2 className="ipr-subtitle">
        تعريف سياسة حقوق الملكية الفكرية
        </h2>
        <p className="ipr-text">
        تُعرَّف حقوق الملكية الفكرية بأنها مصطلح عام وُضع لحماية الحقوق المنسوبة لأصحابها، سواءً كانوا أفرادًا أو شركات أو مؤسسات خاصة أو حكومية؛ على سبيل المثال لا الحصر، براءات الاختراع، وحقوق الطبع والنشر، والعلامات التجارية. ويمكن اعتبار حقوق الملكية الفكرية حقًا قانونيًا مُستحدثًا للحفاظ، على سبيل المثال لا الحصر، على الابتكارات أو المؤلفات أو المقالات أو الصور في جميع المجالات الأدبية أو العلمية أو الصناعية أو التصنيعية، أو إعلانات العقارات المملوكة أو التي حصل مالكها على ترخيص عقاري حصري أو حقوق طبع ونشر غير حصرية، أو كل ما يُقاس عليه ما ذُكر ويمنع الآخرين من انتهاكه أو نسبته إليهم. كما تعني سياسة حقوق الملكية الفكرية منح الحق، بشكل دائم أو مؤقت، للغير بأي شكل يُوثِّق موافقة صاحب الحق (الطرف الأول) على استخدام حقه للطرف الثاني.
        </p>
      </section>

      <section className="ipr-section">
        <h2 className="ipr-subtitle">سياسة حقوق الملكية الفكرية</h2>
        <p className="ipr-text">
        تتبع هذه السياسة الشروط والضوابط واللوائح المعمول بها في المملكة العربية السعودية فيما يتعلق بحقوق الملكية الفكرية، دون أي تعارض معها، كما لا تتعارض مع أي اتفاقيات دولية انضمت إليها المملكة العربية السعودية أو وافقت على محتواها. تحظر سياسة حقوق الملكية الفكرية لدينا سرقة أو انتهاك أي علامة تجارية (عالمية أو محلية) أو اسم تجاري أو انتحال شخصية مشهورة أو إعلانات مملوكة أو مصرح بها حصريًا أو غير حصري. يحق لنا إزالة أي شيء ينتهك سياسة الملكية الفكرية من المنصة، ويحق لنا منع أي شخص ينتهكها أو يتعدى عليها من استخدام المنصة مؤقتًا أو دائمًا.
        </p>
      </section>
    </div>
    <Footer/>
    </>
  );
};

export default Intellectualpropertyrights;
